import { render, staticRenderFns } from "./ActiveUniRequists.vue?vue&type=template&id=d1e3f7f6&"
import script from "./ActiveUniRequists.vue?vue&type=script&lang=js&"
export * from "./ActiveUniRequists.vue?vue&type=script&lang=js&"
import style0 from "./ActiveUniRequists.vue?vue&type=style&index=0&id=d1e3f7f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports